export default "__VITE_ASSET__BI1l66E5__"